{
  "PAGINATION_FOOTER": {
    "SHOWING": "Showing {startItem} - {endItem} of {totalItems} items",
    "CURRENT_PAGE_INFO": "{currentPage} of {totalPages} pages"
  },
  "COMBOBOX": {
    "PLACEHOLDER": "Select an option...",
    "EMPTY_SEARCH_RESULTS": "No items found for the search term `{searchTerm}`",
    "EMPTY_STATE": "Результатів не знайдено.",
    "SEARCH_PLACEHOLDER": "Search...",
    "MORE": "+{count} більше"
  },
  "DROPDOWN_MENU": {
    "SEARCH_PLACEHOLDER": "Search...",
    "EMPTY_STATE": "Результатів не знайдено.",
    "SEARCHING": "Шукаємо..."
  },
  "DIALOG": {
    "BUTTONS": {
      "CANCEL": "Скасувати",
      "CONFIRM": "Підтвердити"
    }
  },
  "PHONE_INPUT": {
    "SEARCH_PLACEHOLDER": "Search country",
    "ERROR": "Phone number should be empty or in E.164 format",
    "DIAL_CODE_ERROR": "Будь ласка, виберіть телефонний код зі списку"
  },
  "THUMBNAIL": {
    "AUTHOR": {
      "NOT_AVAILABLE": "Автор недоступний"
    }
  },
  "BREADCRUMB": {
    "ARIA_LABEL": "Breadcrumb"
  },
  "SWITCH": {
    "TOGGLE": "Toggle switch"
  },
  "LABEL": {
    "TAG_BUTTON": "tag"
  },
  "FEATURE_SPOTLIGHT": {
    "LEARN_MORE": "Детальніше",
    "WATCH_VIDEO": "Watch video"
  },
  "COLOR_GRID": {
    "SHOW_COLORS": "Показати кольори",
    "HIDE_COLORS": "Сховати кольори"
  },
  "DURATION_INPUT": {
    "MINUTES": "Хвилини",
    "HOURS": "Години",
    "DAYS": "Дні",
    "PLACEHOLDER": "Введіть тривалість"
  }
}
